import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportMxAccount } from 'dashboard/models/report/integration/mx-account';

interface MxAccountProps {
  report: ReportMxAccount;
  isRedacted: boolean;
}

const MxAccount: VFC<MxAccountProps> = ({
  report: {
    attributes: {
      query: {
        'name-first': nameFirst,
        'name-middle': nameMiddle,
        'name-last': nameLast,
        'business-name': businessName,
        'user-guid': userGuid,
        'member-guid': memberGuid,
      },
    },
  },
  isRedacted,
}: MxAccountProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='First Name'
        value={nameFirst}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__name-first'
      />
      <AttributeItem
        title='Middle Name'
        value={nameMiddle}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__name-middle'
      />
      <AttributeItem
        title='Last Name'
        value={nameLast}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__name-last'
      />
      <AttributeItem
        title='Business Name'
        value={businessName}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__business-name'
      />
      <AttributeItem
        title='User GUID'
        value={userGuid}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__user-guid'
      />
      <AttributeItem
        title='Member GUID'
        value={memberGuid}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-mx-account__member-guid'
      />
    </AttributeGrid>
  );
};

export default MxAccount;
